export default __webpack_public_path__ + "static/media/decorativa6.ca6d2ad1.jpg";